import { ThemeProvider } from '@shopify/restyle';
import { restyleTheme } from '@webstore-monorepo/shared/theme';
import type { ReactElement } from 'react';
import React from 'react';
import { renderToString as reactDomRenderToString } from 'react-dom/server';

export const renderToString = (element: ReactElement): string => reactDomRenderToString(<ThemeProvider theme={restyleTheme}>{element}</ThemeProvider>);
